// extracted by mini-css-extract-plugin
var _1 = "sRofw";
var _2 = "QoMYi";
var _3 = "JeWTW";
var _4 = "XSMxj";
var _5 = "PnPnR";
export { _1 as "base", _2 as "content", _3 as "main", _4 as "splitPane", _5 as "toolbar" }
